import React from 'react';
import { string } from 'prop-types';
import { Container } from './ShareLinksSkeleton.styles';
var ShareLinksSkeleton = function ShareLinksSkeleton(_ref) {
  var width = _ref.width,
    height = _ref.height,
    variation = _ref.variation;
  return React.createElement(Container, {
    "data-testid": "share-links-skeleton",
    width: width,
    height: height,
    variation: variation
  });
};
process.env.NODE_ENV !== "production" ? ShareLinksSkeleton.propTypes = {
  height: string,
  variation: string,
  width: string.isRequired
} : void 0;
ShareLinksSkeleton.defaultProps = {
  height: '32px',
  variation: 'rectangular'
};
export default ShareLinksSkeleton;